// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import css from './sweetProducts.css'
import { i18n } from '../index'
import Container from '../../common/container/Container'
import classNames from 'classnames'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { Alert, Button, Snackbar } from '@mui/material'
import get from 'lodash/get'
import moment from 'moment'
import capitalize from 'lodash/capitalize'
import { Link } from 'react-router-dom'
import ProductTable from './ProductTable'
import CopyFromDayDialog from './CopyFromDayDialog'
import { vitrineProductTargets } from './productQueries'
import { Query } from 'react-apollo'
import Loader from '../../common/loader/Loader'
import withActiveStation from '../station/withActiveStation'
import type { Station } from '../station/stationTypes'
type Props = {
  match: any
  history: any
  activeStation: Station
}
type State = {
  activeTab: string
  copyDialogOpen: boolean
  copySourceDate: string | null
  copying: boolean
  copyError: string | null
  copySuccess: boolean
}
const DATE_FORMAT = 'YYYY-MM-DD'
const BASE_PATH = '/vitriinien-esillepano/makean-vitriinin-esillepano'
const PRODUCT_TABLE_TABS = ['06', '10', '15', '21', '01']

@withActiveStation
class SweetProducts extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: PRODUCT_TABLE_TABS[0],
      copyDialogOpen: false,
      copySourceDate: null,
      copying: false,
      copyError: null,
      copySuccess: false,
    }
  }

  productTableRef = React.createRef()

  getDate = () => {
    const { match } = this.props
    const date = get(match, 'params.date')

    // Default to current week, if params didn't have a week or it's in an invalid format.
    if (!date || !moment(date).isValid()) {
      return moment().format(DATE_FORMAT)
    }

    return date
  }
  getNextLink = () => {
    return `${BASE_PATH}/${moment(this.getDate()).add(1, 'day').format(DATE_FORMAT)}`
  }
  getPrevLink = () => {
    return `${BASE_PATH}/${moment(this.getDate()).add(-1, 'day').format(DATE_FORMAT)}`
  }
  getDateString = () => {
    return capitalize(moment(this.getDate()).format('dddd D.M.YYYY'))
  }
  onTabClick = (tab) => {
    this.setState({
      activeTab: tab,
    })
  }
  isToday = () => this.getDate() === moment().format(DATE_FORMAT)
  openCopyDialog = () => this.setState({ copyDialogOpen: true })
  closeCopyDialog = () => this.setState({ copyDialogOpen: false })
  onCopyConfirm = (sourceDate) => {
    this.setState({ copyDialogOpen: false, copying: true, copySourceDate: sourceDate })
  }
  onCopySourceFetched = async (data) => {
    const sourceItems = get(data, 'vitrineProductTargets', []) || []
    if (!sourceItems.length) {
      this.setState({ copying: false, copySourceDate: null, copyError: i18n.t('productTable.copyFromDayNoData') })
      return
    }
    try {
      await this.productTableRef.current?.applyCopiedItems(sourceItems)
      this.setState({ copying: false, copySourceDate: null, copySuccess: true })
    } catch (e) {
      this.setState({ copying: false, copySourceDate: null, copyError: i18n.t('productTable.copyFromDayError') })
    }
  }
  onCopyError = () => {
    this.setState({ copying: false, copySourceDate: null, copyError: i18n.t('productTable.copyFromDayError') })
  }
  closeCopyError = () => this.setState({ copyError: null })
  closeCopySuccess = () => this.setState({ copySuccess: false })

  render() {
    const { activeStation } = this.props
    const { copySourceDate } = this.state
    return (
      <Query
        query={vitrineProductTargets}
        variables={{
          stationId: activeStation.id,
          date: this.getDate(),
          productType: 'Sweet',
          vitrineProductType: 'Sweet',
        }}
        fetchPolicy={'cache-and-network'}
      >
        {({ loading, error, data }) => {
          const customerTarget = get(data, 'customerTargets[0].target', 0) || '-'
          const products = get(data, 'vitrineProductTargets', []) || []
          return (
            <Container>
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <div className={css.customerTarget}>
                  <p className={css.label}>{i18n.t('products.customerTargetLabel')}</p>
                  <p className={css.value}>{customerTarget}</p>
                </div>
                <div className={css.nav}>
                  <div className={css.navContent}>
                    <Link className={classNames(css.navLink, css.navLinkPrev)} to={this.getPrevLink()}>
                      <KeyboardArrowLeftIcon />
                    </Link>
                    <div className={css.navDate}>{this.getDateString()}</div>
                    <Link className={classNames(css.navLink, css.navLinkNext)} to={this.getNextLink()}>
                      <KeyboardArrowRightIcon />
                    </Link>
                  </div>
                </div>
                {this.isToday() && (
                  <div className={css.copyFromDay}>
                    <Button variant='outlined' onClick={this.openCopyDialog} disabled={this.state.copying}>
                      {i18n.t('productTable.copyFromDayButton')}
                    </Button>
                  </div>
                )}
                <div className={css.table}>
                  <ProductTable
                    ref={this.productTableRef}
                    stationId={activeStation.id}
                    tabs={PRODUCT_TABLE_TABS}
                    activeTab={this.state.activeTab}
                    items={products}
                    onTabClick={this.onTabClick}
                    date={this.getDate()}
                  />
                </div>
              </Loader>
              <CopyFromDayDialog
                open={this.state.copyDialogOpen}
                loading={this.state.copying}
                maxDate={moment().subtract(1, 'day')}
                onClose={this.closeCopyDialog}
                onConfirm={this.onCopyConfirm}
              />
              {!!copySourceDate && (
                <Query
                  query={vitrineProductTargets}
                  variables={{
                    stationId: activeStation.id,
                    date: copySourceDate,
                    productType: 'Sweet',
                    vitrineProductType: 'Sweet',
                  }}
                  fetchPolicy='network-only'
                  onCompleted={this.onCopySourceFetched}
                  onError={this.onCopyError}
                >
                  {() => <React.Fragment />}
                </Query>
              )}
              <Snackbar open={this.state.copySuccess} autoHideDuration={4000} onClose={this.closeCopySuccess}>
                <Alert onClose={this.closeCopySuccess} severity='success'>
                  {i18n.t('productTable.copyFromDaySuccess')}
                </Alert>
              </Snackbar>
              <Snackbar open={!!this.state.copyError} autoHideDuration={6000} onClose={this.closeCopyError}>
                <Alert onClose={this.closeCopyError} severity='error'>
                  {this.state.copyError}
                </Alert>
              </Snackbar>
            </Container>
          )
        }}
      </Query>
    )
  }
}

export default SweetProducts
